import React, {useEffect, useState, useRef}from 'react'
import { useDispatch, useSelector } from 'react-redux'  
import { MediaSectionContainer  } from 'components/media/media.styled' 
import { Modal } from '@mui/material'  
import { useNavigate } from 'react-router-dom'
import { MUIModalWrap } from 'components/modal/modal.styled'  
import { setViewImageUploadModal, setViewGallery } from 'features/images/imagesSlice'
import ImageUploadModal from './ImageUploadModal'
import ImagesFeed from './ImageFeed'
import Gallery from './Gallery'

export default function Images() {
 
    const navigate = useNavigate() 
    const searchInputRef = useRef(null)
    const dispatch = useDispatch() 
    const { viewImageUploadModal, viewGallery } = useSelector((state) => state.images) 

    const handleResetAfterClose = () => { 
    }

    const handleClearSearch = () => { 
    }

    const handleSearch = () => {   
    }
 

 

    return (
        <MediaSectionContainer>
            <ImagesFeed />
  
            <Modal
                open={viewImageUploadModal}
                onClose={() => dispatch(setViewImageUploadModal(false))}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                >
                    <MUIModalWrap>
                        <ImageUploadModal />
                    </MUIModalWrap>
            </Modal>

            <Modal
                open={viewGallery}
                onClose={() => dispatch(setViewGallery(false))}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                >
                    <Gallery />
            </Modal>

        </MediaSectionContainer>

    )
}
